import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuItem } from '../menu-item';
import { Router } from '@angular/router';
import { AuthService } from '../../app/components/services/auth.service';
import { MenuVisibilityService } from '../Services/menu-visibility.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit, OnDestroy {
  isMobile: boolean | undefined;
  user: any = null;
  currentMenuItems: MenuItem[] = [];

  private subs = new Subscription();

  constructor(
    private router: Router,
    private authService: AuthService,
    private menuVisibility: MenuVisibilityService
  ) {}

  ngOnInit(): void {
    this.checkisMobile();

    this.subs.add(
      this.authService.currentUser$.subscribe(user => {
        this.user = user;
        this.rebuildMenu();
      })
    );

    this.subs.add(
      this.menuVisibility.visibilityChanges$.subscribe(() => {
        this.rebuildMenu();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private rebuildMenu(): void {
    const role = this.user?.role === 'provider' ? 'provider'
               : this.user?.role === 'customer' ? 'customer'
               : this.user?.role === 'admin'    ? 'provider'   // admin sees provider menu + admin item
               : 'guest';
    this.currentMenuItems = this.menuVisibility.getVisibleItems(role);
  }

  isProvider(): boolean { return this.user?.role === 'provider' || this.user?.role === 'admin'; }
  isCustomer(): boolean { return this.user?.role === 'customer'; }
  isAdmin():    boolean { return this.user?.role === 'admin'; }

  checkisMobile() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.isMobile = width < 768;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/home']);
  }
}
